import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal__required-text" }
const _hoisted_2 = { class: "modal__selection-container" }
const _hoisted_3 = { class: "modal__selection modal__selection--4-column" }
const _hoisted_4 = { class: "modal__selection modal__selection--5-column" }
const _hoisted_5 = { class: "modal__selection-container modal__selection modal__new-selection modal__selection-user-input modal__selection--4-column" }

import { useUnmanagedBusinessStore } from '@/unmanagedBusinessModule/pages/unmanagedBusinessStore';
import { storeToRefs } from 'pinia';
import { i18n } from '@/i18n';
import TextInput from './TextInput.vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import SimpleSelectInput from '@/corePagesModule/components/SelectInput.vue';
import SelectInput from '@/corePagesModule/SelectInput/SelectInput.vue';
import { computed, ref, watch } from 'vue';
import { useForms } from '@/corePagesModule/composables/useForm';
import { validateRuleKeyMap, selectOptionKeyMap } from '../constants/formKeyMap';
import { UnmanagedBusinessService } from '../domains/services/UnmanagedBusinessService';
import { FieldItem, ValidateRule } from '@/coreDomainsModule/constant/validateRules';


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterLeadTimeAndEtcModal',
  setup(__props) {

const t = i18n.t;

const store = useUnmanagedBusinessStore();
const { state } = storeToRefs(store);
const { closeModal, openModalByPreviousModal } = store;

const filedItemsKey = [
  'leadTime',
  'leadTimeUnit',
  'MOQ',
  'unit',
  'stdInventoryIndicesMin',
  'stdInventoryIndicesMax',
  'stdInventoryIndicesUnit',
  'manufacturer',
];

const isOpenManufacturerSelectInput = ref(false);

const filedItems = computed((): FieldItem[] => {
  // 選択肢の項目を取得
  const items: FieldItem[] = [];
  filedItemsKey.forEach((item) => {
    items.push({
      name: item,
      rules: validateRuleKeyMap[item],
    });
  });
  return items;
});

const { fieldState, allValidate, resetForm } = useForms(filedItems.value);

/**
 * 次へボタンクリック時の処理
 */
const onNext = () => {
  if (allValidate()) {
    state.value.settingUnmanagedBusiness.leadTime = Number(fieldState['leadTime'].value.value);
    state.value.settingUnmanagedBusiness.leadTimeUnit = UnmanagedBusinessService.convertUnitToSystemUnit(
      fieldState['leadTimeUnit'].value.value
    );
    state.value.settingUnmanagedBusiness.moq = Number(fieldState['MOQ'].value.value);
    state.value.settingUnmanagedBusiness.unit = fieldState['unit'].value.value;
    state.value.settingUnmanagedBusiness.stdInventoryIndices = {
      標準在庫指数: {
        min: Number(fieldState['stdInventoryIndicesMin'].value.value),
        max: Number(fieldState['stdInventoryIndicesMax'].value.value),
        option: {
          unit: UnmanagedBusinessService.convertUnitToSystemUnit(fieldState['stdInventoryIndicesUnit'].value.value),
        },
      },
    };
    state.value.settingUnmanagedBusiness.manufacturer = fieldState['manufacturer'].value.value;
    openModalByPreviousModal('questionUpdateExistBusinessLeadTimeAndStdInventoryIndices');
  }
};

watch(
  () => state.value.modalInfo.isOpen.questionUpdateExistBusinessLeadTimeAndStdInventoryIndices,
  (value) => {
    if (value) {
      resetForm(filedItems.value);
      // settingUnmanagedBusinessの値をfieldStateにセット
      for (let i = 0; i < filedItems.value.length; i++) {
        const name = filedItems.value[i].name;
        fieldState[name].setValue(state.value.modalInfo.modalState.registerLeadTimeAndEtc[name], false);
      }
    }
  }
);

/**
 * バリデーションにRequiredがある場合は*を返す
 * @param key　- 入力項目のキー
 */
const getRequiredMark = (key: string | number) => {
  if (validateRuleKeyMap[key].includes(ValidateRule.Required)) {
    return '*';
  }
  return '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _unref(state).modalInfo.isOpen.questionUpdateExistBusinessLeadTimeAndStdInventoryIndices,
    "back-button-label": _unref(t)('キャンセル'),
    "next-button-label": _unref(t)('次へ'),
    onOnBack: _cache[9] || (_cache[9] = ($event: any) => (_unref(closeModal)('questionUpdateExistBusinessLeadTimeAndStdInventoryIndices'))),
    onOnNext: onNext
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('リードタイム・標準在庫指数・MOQ・単位の登録')), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('リードタイム、標準在庫指数、MOQ(最小発注数量)、単位を登録してください。')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)('*マークは必須')), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(TextInput, {
              "model-value": _unref(state).modalInfo.modalState.registerLeadTimeAndEtc.warehouseNumber,
              label: _unref(t)('取引登録モーダル選択肢:warehouseNumber') + getRequiredMark('warehouseNumber'),
              disabled: ""
            }, null, 8, ["model-value", "label"]),
            _createVNode(TextInput, {
              "model-value": _unref(state).modalInfo.modalState.registerLeadTimeAndEtc.warehouseName,
              label: _unref(t)('取引登録モーダル選択肢:warehouseName') + getRequiredMark('warehouseName'),
              disabled: ""
            }, null, 8, ["model-value", "label"]),
            _createVNode(TextInput, {
              "model-value": _unref(state).modalInfo.modalState.registerLeadTimeAndEtc.supplierNumber,
              label: _unref(t)('取引登録モーダル選択肢:supplierNumber') + getRequiredMark('supplierNumber'),
              disabled: ""
            }, null, 8, ["model-value", "label"]),
            _createVNode(TextInput, {
              "model-value": _unref(state).modalInfo.modalState.registerLeadTimeAndEtc.supplierName,
              label: _unref(t)('取引登録モーダル選択肢:supplierName') + getRequiredMark('supplierName'),
              disabled: ""
            }, null, 8, ["model-value", "label"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TextInput, {
              "model-value": _unref(state).modalInfo.modalState.registerLeadTimeAndEtc.businessNumber,
              label: _unref(t)('取引登録モーダル選択肢:businessNumber') + getRequiredMark('businessNumber'),
              disabled: ""
            }, null, 8, ["model-value", "label"]),
            _createVNode(TextInput, {
              "model-value": _unref(state).modalInfo.modalState.registerLeadTimeAndEtc.businessName,
              label: _unref(t)('取引登録モーダル選択肢:businessName') + getRequiredMark('businessName'),
              disabled: ""
            }, null, 8, ["model-value", "label"]),
            _createVNode(TextInput, {
              "model-value": _unref(state).modalInfo.modalState.registerLeadTimeAndEtc.package,
              label: _unref(t)('取引登録モーダル選択肢:package') + getRequiredMark('package'),
              disabled: ""
            }, null, 8, ["model-value", "label"]),
            _createVNode(TextInput, {
              "model-value": _unref(state).modalInfo.modalState.registerLeadTimeAndEtc.unit,
              label: _unref(t)('取引登録モーダル選択肢:unit') + getRequiredMark('unit'),
              "is-error": _unref(fieldState).unit.isError.value,
              "error-message": _unref(fieldState).unit.errorMessage.value,
              placeholder: _unref(t)('取引登録モーダル選択肢:unit'),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = (e) => _unref(fieldState).unit.setValue(e))
            }, null, 8, ["model-value", "label", "is-error", "error-message", "placeholder"]),
            _createVNode(SelectInput, {
              "model-value": _unref(state).modalInfo.modalState.registerLeadTimeAndEtc.manufacturer,
              "filter-type": 'MANUFACTURER',
              index: 1,
              label: _unref(t)('取引登録モーダル選択肢:manufacturer') + getRequiredMark('manufacturer'),
              placeholder: _unref(t)(`取引登録モーダル選択肢:manufacturer`),
              "is-open-prop": isOpenManufacturerSelectInput.value,
              "is-error": _unref(fieldState).manufacturer.isError.value,
              "error-message": _unref(fieldState).manufacturer.errorMessage.value,
              "prop-options": _unref(state).tableInfo[_unref(state).selectedFileType].selectOptionInfo['manufacturer'],
              "onClick:selectInput": _cache[1] || (_cache[1] = () => (isOpenManufacturerSelectInput.value = false)),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = (e) => _unref(fieldState).manufacturer.setValue(e))
            }, null, 8, ["model-value", "label", "placeholder", "is-open-prop", "is-error", "error-message", "prop-options"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TextInput, {
          "model-value": _unref(fieldState).leadTime.value.value,
          label: _unref(t)('取引登録モーダル選択肢:leadTime') + getRequiredMark('leadTime'),
          "is-error": _unref(fieldState).leadTime.isError.value,
          "error-message": _unref(fieldState).leadTime.errorMessage.value,
          placeholder: _unref(t)('取引登録モーダル選択肢:leadTime'),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = (e) => _unref(fieldState).leadTime.setValue(e))
        }, null, 8, ["model-value", "label", "is-error", "error-message", "placeholder"]),
        _createVNode(SimpleSelectInput, {
          "model-value": _unref(fieldState).leadTimeUnit.value.value,
          index: 4,
          label: _unref(t)('取引登録モーダル選択肢:leadTimeUnit') + getRequiredMark('leadTimeUnit'),
          "is-error": _unref(fieldState).leadTimeUnit.isError.value,
          "error-message": _unref(fieldState).leadTimeUnit.errorMessage.value,
          placeholder: _unref(t)('取引登録モーダル選択肢:leadTimeUnit'),
          options: _unref(selectOptionKeyMap).leadTimeUnit.map((item) => _unref(t)(item)),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = (e) => _unref(fieldState).leadTimeUnit.setValue(e))
        }, null, 8, ["model-value", "label", "is-error", "error-message", "placeholder", "options"]),
        _createVNode(TextInput, {
          "model-value": _unref(fieldState).MOQ.value.value,
          label: _unref(t)('取引登録モーダル選択肢:MOQ') + getRequiredMark('MOQ'),
          "is-error": _unref(fieldState).MOQ.isError.value,
          "error-message": _unref(fieldState).MOQ.errorMessage.value,
          placeholder: _unref(t)('取引登録モーダル選択肢:MOQ'),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = (e) => _unref(fieldState).MOQ.setValue(e))
        }, null, 8, ["model-value", "label", "is-error", "error-message", "placeholder"]),
        _createVNode(TextInput, {
          "model-value": _unref(fieldState).stdInventoryIndicesMin.value.value,
          label: _unref(t)('取引登録モーダル選択肢:stdInventoryIndicesMin') + getRequiredMark('stdInventoryIndicesMin'),
          "is-error": _unref(fieldState).stdInventoryIndicesMin.isError.value,
          "error-message": _unref(fieldState).stdInventoryIndicesMin.errorMessage.value,
          placeholder: _unref(t)('取引登録モーダル選択肢:stdInventoryIndicesMin'),
          "onUpdate:modelValue": _cache[6] || (_cache[6] = (e) => _unref(fieldState).stdInventoryIndicesMin.setValue(e))
        }, null, 8, ["model-value", "label", "is-error", "error-message", "placeholder"]),
        _createVNode(TextInput, {
          "model-value": _unref(fieldState).stdInventoryIndicesMax.value.value,
          label: _unref(t)('取引登録モーダル選択肢:stdInventoryIndicesMax') + getRequiredMark('stdInventoryIndicesMax'),
          "is-error": _unref(fieldState).stdInventoryIndicesMax.isError.value,
          "error-message": _unref(fieldState).stdInventoryIndicesMax.errorMessage.value,
          placeholder: _unref(t)('取引登録モーダル選択肢:stdInventoryIndicesMax'),
          "onUpdate:modelValue": _cache[7] || (_cache[7] = (e) => _unref(fieldState).stdInventoryIndicesMax.setValue(e))
        }, null, 8, ["model-value", "label", "is-error", "error-message", "placeholder"]),
        _createVNode(SimpleSelectInput, {
          "model-value": _unref(fieldState).stdInventoryIndicesUnit.value.value,
          index: 6,
          label: _unref(t)('取引登録モーダル選択肢:stdInventoryIndicesUnit') + getRequiredMark('stdInventoryIndicesUnit'),
          "is-error": _unref(fieldState).stdInventoryIndicesUnit.isError.value,
          "error-message": _unref(fieldState).stdInventoryIndicesUnit.errorMessage.value,
          placeholder: _unref(t)('取引登録モーダル選択肢:stdInventoryIndicesUnit'),
          options: _unref(selectOptionKeyMap).stdInventoryIndicesUnit.map((item) => _unref(t)(item)),
          "onUpdate:modelValue": _cache[8] || (_cache[8] = (e) => _unref(fieldState).stdInventoryIndicesUnit.setValue(e))
        }, null, 8, ["model-value", "label", "is-error", "error-message", "placeholder", "options"])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label"]))
}
}

})